/**
 * Parse Nord Health booking URLs for book-appointment-widget preselections.
 * Example:
 * ...?date=2026-03-20&treatmentGroups=29&treatmentGroups=16&therapist=uuid&...
 */
export type NordBookingPreselections = {
  preselectedServiceId?: string;
  preselectedTherapistUuid?: string;
};

export function parseNordBookingPreselectionUrl(
  raw: string | null | undefined
): NordBookingPreselections {
  if (raw == null || typeof raw !== 'string') return {};
  const s = raw.trim();
  if (!s) return {};

  let url: URL;
  try {
    url = new URL(s);
  } catch {
    try {
      url = new URL(s, 'https://www.nordhealth.fi');
    } catch {
      return {};
    }
  }

  const treatmentGroups = url.searchParams.getAll('treatmentGroups');
  return {
    preselectedServiceId: treatmentGroups[0] || undefined,
    preselectedTherapistUuid: url.searchParams.get('therapist') || undefined,
  };
}
